export default {
    user_export_remind_1: "This operation will download the user's Excel file, confirm to proceed?",
    remind: "Reminder",
    confirm: "confirm",
    cancel: "Cancel",
    start_download: "start download",
    cancel_download: "Cancel download",
    modify_success: "Successfully modified",
    enabled: "Enable",
    disabled: "Not Enabled",
    open: "open",
    unopen: "Not open",
    ac:"pay",
    dc:"DC",
    common_00241: "Added successfully",
    charging_capacity:"Charging capacity (degrees)",
    service_fee_amount:"Service fee (yuan)",
    paid_amount:"Total actually paid (yuan)",
    notUserGroup_order_paid:"Non-group paid charging order",
    level_day_task1:"No need for relegation tasks for users of all levels",
    level_day_task2:"Relegation tasks for users of all levels every 30 days",
    level_day_task3:"Relegation tasks for users of all levels every 90 days",
    level_initial:"Initialize the user level",
    level_initial_time:"Start time of user initialization level data:",
    selectTime: "selection period",
    initial:"initialization",
    think_again:"Think again",
    initial_info_wait:"Initializing the user level, please wait...",
    initial_info_success:"Successfully initialized the user level!",
    fee_policy_push_remind1:'If the rates standard is modified, click the "Apply rates" button in the site details-rates standard, and the rates will take effect!',
    fee_policy_push_remind2:"The total cost of a single charge is not discounted (%)",
    fee_policy_push_remind3:"Discount on service charge for a single charge (%)",
    fee_policy_push_remind4:"The total cost of a single charge is discounted (%）",
    member_00000: 'Member Management',
    member_00001: 'member information',
    member_00002: 'Affiliate marketing',
    member_00003: 'Membership level setting',
    member_00004: 'Member rights settings',
    member_00005: 'Membership level activated',
    member_00006: 'open',
    member_00007: 'close',
    member_00008: 'Export user',
    member_00009: 'Level (from low to high)',
    member_00010: 'class',
    member_00011: 'Grade name',
    member_00012: 'User number',
    member_00013: 'Number of marketing activities',
    member_00014: 'Marketing activities',
    member_00015: 'View users',
    member_00016: 'Marketing activity control',
    member_00017: 'Whether to enable the coupon discount',
    member_00018: 'Setup help',
    member_00019: '1. If it is set to enable coupon discounts, users of the level can use coupons when paying for orders; if it is set to not enable coupon discounts, users of the level cannot use coupons when paying for orders.',
    member_00020: '2. Priority is given to using level user privileges when paying orders, and the bill amount after using level user privileges is then selected according to the card coupons meeting conditions.',
    member_00020_1: 'Example: VIP users charge 100 yuan this time (including 70 yuan for electricity and 30 yuan for service fees), can enjoy privileges (15% off service fee for a single charge), and have 1 card coupon (service charge for a single charge meets 20 yuan) 10% off service fee),',
    member_00020_2: 'After using the privileges of the level user, the bill amount is 95.5 yuan (including 70 yuan for electricity and 25.5 yuan for service fee (30*85%)), which meets the card coupon (single charge service fee meets 20 yuan service fee 10% off). After using the card and coupon, the bill amount is 92.95 yuan (including 70 yuan for electricity + 22.95 yuan for service fee (25.5*90%)), and finally 92.95 yuan is actually paid this time.',
    member_00021: 'Exclude the site',
    member_00022: 'After adding a charging station, level users do not enjoy privileges when charging at this charging station',
    member_00023: 'Add excluded sites',
    member_00024: 'Station name',
    member_00025: 'Operator',
    member_00026: 'Station details',
    member_00027: 'Delete',
    member_00028: 'Are you sure to delete this site?',
    member_00029: 'successfully deleted',
    member_00030: 'User scope: WeChat users',
    member_00031: 'Level initialization',
    member_00032: 'edit',
    member_00033: 'cancel',
    member_00034: 'save',
    member_00036: 'Level initialization',
    member_00035: 'After enabling it, please carefully set the user level related parameters. Frequent modification may cause resentment and complaints from charging users. If resetting, please re-initialize the user level.',
    member_00037: 'Types of upgrade/relegation tasks',
    member_00038: '(Non-group and have paid for charging order)',
    member_00039: 'Setup help',
    member_00040: 'Upgrade task: The system automatically upgrades according to the growth value required by users of all levels, and upgrades when the growth value is reached.',
    member_00040_1: 'Relegation task: The system automatically relegates according to the free value required by users of each level. When the free value is reached, it is relegated, and if the free value is not reached, it is relegated. You can choose whether to open the relegation task.',

    member_00041: 'No drop value setting',
    member_00041_1: 'Users get the free value through charging consumption. When the user grows to a new level, they need to obtain the free value required by the relegation within the time period you set for the completion of the relegation task, and the relegation can be successful, otherwise it will be downgraded.',
    member_00041_2: 'Example: When you set to open the relegation task and set it to "complete once every 30 days", set the VIP2 free drop value to 200, when the user upgrades from VIP1 to VIP2, you need to get it every 30 days from the day of the upgrade',
    member_00041_3: 'The 200 waived value can maintain the VIP2 level, otherwise it will be downgraded to VIP1. The result of the success or failure of the relegation will be executed from the first day after the completion of the relegation task cycle.',
    member_00042: 'Membership level setting',
    member_00043: 'Open relegation task',
    member_00044: 'Completed every 30 days',
    member_00045: 'Completed every 90 days',
    member_00046: 'sequence',
    member_00047: 'Membership level (from low to high)',
    member_00048: 'Please enter the class name',
    member_00049: 'Upgrade task',
    member_00050: 'Please enter an integer',
    member_00051: 'Relegation task',
    member_00052: 'Add level',
    member_00053: 'Incorrect format of upgrade task/relegation task',
    member_00054: 'Please fill in the user level name/upgrade task/relegation task',


    member_00055: 'member benefits',
    member_00056: 'Level user rights type',
    member_00057: 'Enter 15% off for 15% off, enter 0 for free, and enter 100 for no discount.',
    member_00058: 'Grade name (grade from low to high)',
    member_00059: 'Member level benefits:',
    member_00061: 'Example: If you set a 15% discount on the service fee for a single charge for VIP users, and the charge for VIP users is 100 yuan this time (including 70 yuan for electricity and 30 yuan for service fees), the actual amount to be paid this time is 95.5 (70+30*85%= 95.5).',
    member_00062: 'If you set a 15% discount on the total cost of a single charge for VIP users, and the charge for VIP users is 100 yuan this time, the actual amount to be paid this time is 85 yuan (100*85%=85).',
    member_00063: 'Membership level discount format error',
    member_00064: 'Please enter the membership level discount',


    member_00065: 'Please enter the charging site name/operator name',
    member_00066: 'Search',
    member_00067: 'Station name',
    member_00068: 'Operator',
    member_00069: 'Station status',
    member_00070: 'Open to the outside',
    member_00071: 'Charger',
    member_00072: 'cancel',
    member_00073: 'add',
    member_00074: 'Growth value setting:',
    member_00075: "The user obtains the growth value through charging consumption. When the user's growth value reaches the corresponding level requirements, the user becomes a member of the corresponding level. The growth value is not accumulated across levels. After each user upgrades, the initial growth value is 0. ",
    member_00076: 'Example: the growth value required for VIP1 is 100, and the growth value required for VIP2 is 200. When the user is a VIP1, he needs to obtain another 200 growth value to become a VIP2. ',

    // 2022/1/17
    member_10000: 'Stored value return activities',
    member_10001: 'Free claim activity',
    member_00077: 'Level reward',
    member_00078: 'When the user completes the upgrade task/relegation task, the reward given to the user. Upgrade/relegation bonuses only take effect when the membership level setting is enabled. ',
    member_00079: 'Level name (from low to high)',
    member_00080: 'Upgrade bonus',
    member_00081: 'Relegation Reward',
    member_00082: 'Reward Settings',
    member_00083: 'Add coupons',
    member_00084: 'If you add a coupon with an absolute time validity period, please note that the coupon will be removed from the reward before the expiration date of the coupon. ',
    member_00084: 'Please enter the card name',
    member_00085: 'Card type',
    member_00086: 'Coupon name',
    member_00087: 'Type',
    member_00088: 'Please enter a multiple of 100, the maximum is 10000',
    member_00089: 'Charge capacity',
    member_00090: 'Service Fee',
    member_00091: 'Reference data',
    member_00092: 'A single user is not a team and has paid a charging order',
    member_00093: 'Actually paid total cost',
    member_00094: 'Member level discount',
    member_00095: "*The system will calculate the charging data of each charging user, the accumulated growth value from the start time to the present, and assign the level according to the level rule you currently set (the calculation process may take a while, please wait patiently). <br>*When you enable the membership level function for the first time, after setting the level parameters, if you want all users to accumulate growth value from 0, there is no need to use the 'Reassign Membership Level' function<br>*When you enable the membership level function for the first time, After setting the level parameters, if you want to assign the membership level based on the user's historical charging data, please use the 'Reassign Membership Level' function. <br>*When you modify the level parameters<br>1. If you set to modify the level name, increase the level, increase the growth value, and increase the non-drop value, after the setting is completed, click the 'Save' button to take effect. Assign Membership Levels. <br>2. If you set the reduction growth value and the non-dropping value, click the 'Save' button to take effect after setting. Some users' accumulated growth value or non-reduction value have not been able to be upgraded or relegated successfully. After you set the growth value reduction or non-reduction value, the upgrade or relegation requirements have been met. In this case, after the user charges once, You can complete the upgrade or relegation task. <br>Example: Previously, you set the required growth value of VP2 to 200, and now you have changed it to 150. A user has accumulated 150 growth value before the modification. After you modify the setting, the user can charge the next time. Upgrade VIP2. <br>3. If you set a reduced level, please use the 'Reassign Membership Level' function after the setting is completed to ensure that the user can obtain the corresponding new level. <br>Example: Previously, you set the level to 5, the highest membership level is VIP5, now set the membership level to 3, the highest membership level is VIP3, a user's membership level was VIP5 before, you need to use 'reset membership level' After that, the user can be assigned to a new membership level",
    member_00096: 'Continue',
    member_00097: 'Conversion ratio',
    member_00098: 'Growth value/No drop value',
    member_00099: '1 degree charging capacity',
    member_000100: '1 yuan service fee',
    member_000101: 'The total cost of 1 yuan paid',
    
}
